export default __webpack_public_path__ + "static/media/facebook.2df6d2b2.svg";